module.exports = __webpack_public_path__ + "img/2.15bc6b28.png";